export default __webpack_public_path__ + "static/media/photo--sm--131.d8b8146a.jpg";